import { render } from "./payReceivable.vue?vue&type=template&id=3737edd5&scoped=true"
import script from "./payReceivable.vue?vue&type=script&lang=js"
export * from "./payReceivable.vue?vue&type=script&lang=js"

import "./payReceivable.vue?vue&type=style&index=0&id=3737edd5&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3737edd5"]])

export default __exports__